<template>
  <div class="app-container">
    <el-card shadow="hover">
      <!-- 查询和其他操作 -->
      <div class="filter-container">
        <!-- <el-input v-model="listQuery.name" clearable class="filter-item" style="width: 200px;" placeholder="请输入标签名称" /> 
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button> -->
        <el-button class="filter-item" type="primary" style="margin-bottom: 10px;" icon="el-icon-edit" @click="handleAsync()">同步企微标签</el-button>
      </div>

      <!-- 查询结果 -->
      <el-table v-loading="listLoading" :data="list" element-loading-text="正在查询中。。。" border fit highlight-current-row
        row-key="id">

        <el-table-column align="left" label="标签名称" prop="name" width="300px" />


        <el-table-column align="center" label="标签标记人数" prop="amount" />

        <el-table-column align="center" label="状态" prop="deleted">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == '0' ? 'success' : 'error'">{{
              scope.row.status == "0" ? '启用' : '停用'
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="备注" prop="remark" show-overflow-tooltip />

        <el-table-column align="center" label="操作" width="300" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-if="scope.row.children == ''" icon="el-icon-edit" type="text" size="mini"
              @click="handleUpdate(scope.row)">编辑对应sql</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--   
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="getList" /> -->

      <!-- 添加或修改对话框 -->
      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="750px">
        <el-form ref="dataForm" :rules="rules" :model="dataForm" status-icon label-position="left" label-width="120px"
          style="width: 600px; margin-left:50px;">


          <el-form-item label="标签名称" prop="name">
            <el-input v-model="dataForm.name" :disabled="true" placeholder="标签名称" />
          </el-form-item>

          <el-form-item label="标签SQL" prop="cusSql">
            <el-input v-model="dataForm.cusSql" rows="8"
              placeholder="符合标签的sql语句 如：select worker_no  from customer_client" type="textarea" />
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" />
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button v-if="dialogStatus == 'create'" type="primary" @click="createData">确定</el-button>
          <el-button v-else type="primary" @click="updateData">修改</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

  
<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";


export default {
  name: "cpTag",
  components: { Pagination },
  filters: {
  },
  data() {
    const validateSql = (rule, value, callback) => {
      if (
        this.dataForm.labelLevel == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请输入标签SQL"));
      } else {
        callback();
      }
    };
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        sort: "create_time",
        order: "desc",
      },
      dataForm: {
        tagId: undefined,
        name: '',
        cusSql: undefined,
        remark: undefined
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑标签",
        create: "创建标签",
      },
      rules: {
        labelName: [
          { required: true, message: "标签标题不能为空", trigger: "blur" },
        ],
        cusSql: [{ validator: validateSql, required: true, trigger: "blur" }],
      },
      downloadLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      service
        .$axiosCpTagList()
        .then((response) => {
          this.list = response.data.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.listLoading = false;
        });
    },
    handleClose(tag) {
      this.keywords.splice(this.keywords.indexOf(tag), 1);
      this.dataForm.labelValue = this.keywords.toString();
    },
    showInput() {
      this.newKeywordVisible = true;
      this.$nextTick((_) => {
        this.$refs.newKeywordInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const newKeyword = this.newKeyword;
      if (newKeyword) {
        this.keywords.push(newKeyword);
        this.dataForm.labelValue = this.keywords.toString();
      }
      this.newKeywordVisible = false;
      this.newKeyword = "";
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm() {
      this.dataForm = {
        tagId: '',
        cusSql: undefined,
        name: '',
        remark: undefined
      };
    },
    handleUpdate(row) {
      console.info(row);
      this.dataForm = {
        tagId: row.id,
        cusSql: row.cusSql,
        name: row.name,
        remark: row.remark
      };

      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
 
    },
    updateData() {
      console.info(this.dataForm)
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          service
            .$axiosCpTagUpdate(this.dataForm)
            .then(() => {
              this.getList();
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "成功",
                message: "更新成功",
              });
            })
            .catch((response) => {
              this.$notify.error({
                title: "失败",
                message: response.data.errmsg,
              });
            });
        }
      });
    },
    handleAsync() {
      service.$axiosCpTagAsync().then(res => {
        this.$notify.success({
          title: "成功",
          message: "同步中，请稍后刷新",
        });
      })
    },
    handleDelete(row) {
      service
        .$axiosWorkerLabelDelete(row)
        .then((response) => {
          this.$notify.success({
            title: "成功",
            message: "停用标签成功",
          });

          this.getList();
        })
        .catch((response) => {
          this.$notify.error({
            title: "失败",
            message: response.data.errmsg,
          });
        });
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.el-button--text {
  padding: 0 !important;
  width: auto !important;
  margin-left: 5px !important;
}

.el-button--text span {
  margin-left: 0px !important;
}
</style>